var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSuccessIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    strokeMiterlimit: 10,
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m490.549 121.217-38.51-38.51c-7.09-7.092-18.589-7.092-25.679 0L195.466 313.603 85.64 202.982c-7.09-7.093-18.59-7.093-25.68 0l-38.509 38.51c-7.093 7.09-7.093 18.589 0 25.679l161.04 162.122c7.092 7.092 18.587 7.092 25.679 0l282.379-282.397c7.093-7.09 7.093-18.589 0-25.679z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSuccessIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "success-icon.9fdd44eb2a56a915c20c9c4c68322d0e.svg";